module.exports = __webpack_public_path__ + "img/1.335eb93a.png";